<template>
  <a class="home-author-card home-card-frame" :href="safeHttpUrl(author.href)">
    <img class="home-author-card__avatar" :src="author.profile_photo" :alt="author.name" loading="lazy" @error="onImageError" />
    <strong>{{ author.name }}</strong>
    <small>{{ compactNumber(author.followers) }} seguidores</small>
  </a>
</template>

<script>
import { compactNumber } from "@/utils/homeMetrics";
import { HOME_AVATAR_FALLBACK, setImageFallback } from "@/utils/homeImageFallbacks";
import { sanitizeHttpUrl } from "@/utils/safeNavigation";

export default {
  name: "HomeAuthorCard",
  props: {
    author: { type: Object, required: true },
  },
  methods: {
    safeHttpUrl: sanitizeHttpUrl,
    compactNumber,
    onImageError(event) {
      setImageFallback(event, HOME_AVATAR_FALLBACK);
    },
  },
};
</script>
